import React from "react";
import DailyReport from "app/modules/reports/daily-report";

export default function DailyReportPage() {
    return <DailyReport/>
}